<template>
  <div class="html-image__result">
    <v-skeleton-loader
      v-if="skeleton"
      height="100%"
      width="100%"
      type="image"
    />
    <img
      ref="previewImg"
      style="width: 100%"
    >
    <iframe
      ref="previewIframe"
      seamless
      :class="['html-image__iframe', {'fill--height': fillHeight}]"
      :title="uuidv4()"
    />
  </div>
</template>

<script setup lang="ts">
import html2canvas from 'html2canvas';
import { v4 as uuidv4 } from 'uuid';
import {
  onMounted, PropType, ref, watch,
} from 'vue';

const previewImg = ref(undefined as undefined | HTMLImageElement);
const previewIframe = ref(undefined as undefined | HTMLIFrameElement);

const props = defineProps({
  html: { type: Object as PropType<string | undefined>, required: true },
  fillHeight: { type: Boolean, required: false, default: false },
});

const skeleton = ref(true);

const renderImage = () => {
  skeleton.value = true;

  const iframe = previewIframe.value;
  if (!iframe) {
    console.log('[renderImage] No Iframe Element?');
    return;
  }
  console.log(props.html);

  iframe.srcdoc = `
      <style>
        body {margin: 0 !important}
        body > div:first-of-type {
            xmin-width: 100vw !important;
            width: 100% !important;
            align-content: center !important;
        };
      </style>${props.html}`;

  iframe.onload = async () => {
    if (!iframe.contentDocument) {
      console.log('[renderImage] No Iframe Document?');
      return;
    }

    const canvas = await html2canvas(iframe.contentDocument.body, {
      allowTaint: true,
      imageTimeout: 2000,
      useCORS: true,
    });

    const imageDataUrl = canvas.toDataURL('image/png');
    skeleton.value = false;

    previewImg.value!.src = `${imageDataUrl}`;

    // const canvasW = canvas.width;
    // const canvasH = canvas.height;
    // console.log(`[renderImage] w:${canvasW} h:${canvasH}`);
    // td.style.paddingBottom = `${(canvasH / canvasW) * 100}%`;

    iframe.srcdoc = '';
    iframe.onload = null;
  };
};

onMounted(() => renderImage());

watch(
  () => props.html,
  () => { renderImage(); },
);

</script>

<style lang="scss">

.html-image__result {
  width: 100%;
  height: 100%;
  & img {
    vertical-align: top;
  }
}

.html-image__iframe {
  position: absolute;
  border: 0;
  margin: 0;
  padding: 0;
  top: -111110px;
  width: 800px;

  &.fill--height {
    height: 800px;
  }
}

</style>
